import { BriefcaseBusiness, MapPin } from "lucide-react"
import { useState } from "react"

import linkedinLogo from "~/assets/linkedin.png"
import { OSLoader } from "~/components/base-loader"
import { GetEmailButton } from "~/components/recommended-person"
import { getLocationDisplay } from "~/utils/location-helpers"

import BriefCombo from "./BriefCombo"

const MultiplePeopleInformation = ({
  multiplePeople,
  isPersonLoading,
  customPersonas,
  totalAccountData
}: {
  multiplePeople: any[]
  isPersonLoading: boolean
  customPersonas: any
  totalAccountData: any
}) => {
  const [selectedPerson, setSelectedPerson] = useState(
    multiplePeople?.[0] || null
  )

  if (isPersonLoading)
    return (
      <div className="flex justify-center items-center">
        <OSLoader />
      </div>
    )

  const companyId = selectedPerson?.company_id
  const accountData = totalAccountData?.data?.results?.find(
    (ad: any) => ad.company_id === companyId
  )
  const selectedPersonaKey =
    selectedPerson?.linkedin_url_raw || selectedPerson?.url
  const personaLoading =
    !!selectedPersonaKey && !customPersonas[selectedPersonaKey]

  return (
    <div className="flex flex-1 pl-6 overflow-hidden h-full">
      <div className="py-4 w-1/3 overflow-hidden">
        <div className="w-full max-h-full h-fit overflow-auto bg-white dark:bg-dark-3 border-[0.5px] border-light-border dark:border-border rounded-lg">
          {multiplePeople.map((person: any) => (
            <button
              key={person.linkedin_url}
              className={`p-4 flex flex-col gap-2 text-left w-full cursor-pointer border-b-[0.5px] border-light-border dark:border-border last:border-b-0 ${
                selectedPerson?.url === person.url
                  ? "bg-[whitesmoke] dark:bg-dark-2"
                  : ""
              }`}
              onClick={() => setSelectedPerson(person)}
            >
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-2">
                  <p className="font-semibold text-sm">
                    {getLocationDisplay(person.name) || person.name}
                  </p>
                  {person.linkedin_url && (
                    <a
                      href={person.linkedin_url_raw}
                      target="_blank"
                      rel="noreferrer"
                      className="flex"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <img
                        src={linkedinLogo}
                        alt="LinkedIn"
                        width={16}
                        height={16}
                      />
                    </a>
                  )}
                </div>
                <p className="text-xs px-3 py-1 rounded-lg text-dark-6 dark:bg-primary-light bg-primary flex items-center justify-center cursor-pointer">
                  View
                </p>
              </div>
              <div className="text-xs flex items-center gap-1">
                <BriefcaseBusiness className="mr-1" size={16} />
                <p>{person?.title || person?.headline || ""}</p>
              </div>
              {person.location && (
                <div className="text-xs flex items-center gap-1">
                  <MapPin className="mr-1" size={16} />
                  <p>
                    {getLocationDisplay(person.location) || person.location}
                  </p>
                </div>
              )}
              <GetEmailButton
                linkedin_url={person.linkedin_url || person.url}
                key={person.linkedin_url}
              />
            </button>
          ))}
        </div>
      </div>
      <div
        className="w-2/3 overflow-auto"
        key={selectedPerson.id}
        id="brief-container"
      >
        {selectedPerson ? (
          <BriefCombo
            people={selectedPerson}
            selectedPerson={selectedPerson}
            accountData={accountData}
            customPersonas={customPersonas}
            personaLoading={personaLoading}
          />
        ) : (
          <div className="flex justify-center items-center">
            <OSLoader />
          </div>
        )}
      </div>
    </div>
  )
}

export default MultiplePeopleInformation
